import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledContainer, StyledTextFieldContainer, StyledLabel, StyledTextField, StyledDividerContainer, StyledIcon, StyledHelperTextContainer, StyledHelperTextIcon, } from "./InputTextField.style";
import { IconButtonVariants, IconButtonWeights, } from "../../../Molecules/Button/Icon/constants";
import { DividerSizes, DividerVariants, } from "../../../Atoms/Divider/constants";
import { LabelSizes, LabelVariants } from "../../../Atoms/Text/Label/constants";
import { InputMasks, TextFieldTypes } from "./constants";
import React, { forwardRef, useRef } from "react";
import { Icon, IconButton } from "../../../Molecules";
import { Divider, Label } from "../../../Atoms";
import MaskedInput from "react-text-mask";
const InputTextField = forwardRef(({ inputLabel, helperText, inputMask, inputCustomMask, inputMaskOnValue = false, iconName = "", iconButton = false, types = TextFieldTypes.text, isDisabled = false, isError = false, onChange = () => { }, onClick = () => { }, initialValue = "", value, ...props }, ref) => {
    const [focused, setFocused] = React.useState(false);
    const [internalValue, setInternalValue] = React.useState(initialValue);
    const inputMaskRef = useRef(null);
    const currentValue = value !== null && value !== void 0 ? value : internalValue;
    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);
    const getError = (isError) => {
        if (isError) {
            return { ...LabelVariants, variant: LabelVariants.negative };
        }
        return;
    };
    const checkFocus = () => {
        if (!focused || isDisabled || isError) {
            return { ...DividerVariants, variant: DividerVariants.neutral };
        }
        else {
            return {
                ...DividerVariants,
                variant: DividerVariants.primary,
                size: DividerSizes.strong,
            };
        }
    };
    const handleInputMask = () => {
        switch (inputMask) {
            case InputMasks.data: {
                return [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
            }
            case InputMasks.cpf: {
                return [
                    /\d/,
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                ];
            }
            case InputMasks.cnpj: {
                return [
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    "/",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                ];
            }
            case InputMasks.cep: {
                return [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
            }
            case InputMasks.celular: {
                return [
                    "(",
                    /[1-9]/,
                    /\d/,
                    ")",
                    " ",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ];
            }
            default: {
                return [];
            }
        }
    };
    const handleChange = (e) => {
        e.preventDefault();
        if (!isDisabled) {
            const { value } = e.target;
            let newValue = value;
            if ((inputMask || inputCustomMask) && !inputMaskOnValue) {
                newValue = value.replace(/\D/g, "");
            }
            setInternalValue(newValue);
            onChange(e, newValue);
        }
    };
    return (_jsxs(StyledContainer, { isDisabled: isDisabled, children: [_jsxs(StyledTextFieldContainer, { isDisabled: isDisabled, children: [_jsx(StyledLabel, { className: (focused || currentValue) && "active", isError: isError, htmlFor: `ids-react-text-field-input-${value}`, children: _jsx(Label, { variant: LabelVariants.neutral, size: focused || currentValue ? "small" : "medium", weight: focused ? "bold" : "regular", ...getError(isError), children: inputLabel }) }), inputMask || inputCustomMask ? (_jsx(MaskedInput, { mask: inputCustomMask || handleInputMask, onChange: handleChange, value: currentValue, ...props, render: (maskRef, props) => (_jsx(StyledTextField, { id: `ids-react-text-field-input-${value}`, ...props, ref: (el) => {
                                maskRef(el);
                                inputMaskRef.current = el;
                                if (ref && typeof ref !== "function") {
                                    if (ref.hasOwnProperty("current")) {
                                        ref.current = inputMaskRef.current;
                                    }
                                    else {
                                        ref = inputMaskRef;
                                    }
                                }
                            }, isDisabled: isDisabled, disabled: isDisabled, type: types, onFocus: onFocus, onBlur: onBlur, withIcon: !!iconName })) })) : (_jsx(StyledTextField, { ...props, id: `ids-react-text-field-input-${value}`, isDisabled: isDisabled, disabled: isDisabled, type: types, onFocus: onFocus, onBlur: onBlur, onChange: handleChange, ref: ref, value: currentValue, withIcon: !!iconName })), iconName && iconButton && (_jsx(StyledIcon, { iconButton: iconButton, children: _jsx(IconButton, { iconName: iconName, onClick: onClick, weight: IconButtonWeights.medium, variant: IconButtonVariants.primary, isDisabled: isDisabled }) })), iconName && !iconButton && (_jsx(StyledIcon, { iconButton: iconButton, children: _jsx(Icon, { name: iconName, size: "medium", variant: "primary", isDisabled: isDisabled }) }))] }), _jsx(StyledDividerContainer, { children: _jsx(Divider, { ...checkFocus() }) }), _jsxs(StyledHelperTextContainer, { children: [isError && (_jsx(StyledHelperTextIcon, { children: _jsx(Icon, { name: "itaufonts_exclamacao", size: "small", variant: "negative" }) })), helperText && (_jsx(Label, { size: LabelSizes.xsmall, variant: LabelVariants.neutral, ...getError(isError), children: helperText }))] })] }));
});
export default InputTextField;
//# sourceMappingURL=InputTextField.js.map